export const Projetos = () => {
    return (
        <>
            <h1 className="text-center mt-5 mb-5">Experiencia</h1>

            <div class="card-group card-area">
                <div class="cardItem">
                    <div class="card-body">
                    <h5 class="card-title text-center">AutoNota</h5>
                    <p class="p">
                        Sistema onde os próprios funcionários de uma empresa mecânica, podem criar suas próprias notas de serviço. O sistema inclui funcionalidades como listagem de notas, geração de relatórios, e uma área onde os mecânicos podem visualizar sua produtividade e acompanhar o quanto produziram no mês.
                    </p>
                    <a href="https://baypel.online" target="_blank">https://baypel.online</a>
                    </div>
                </div>

                <div class="cardItem">
                   
                    <div class="card-body">
                    <h5 class="card-title text-center">PDV</h5>
                    <p class="p">
                        Projeto PDV (Ponto de Venda): Desenvolvi um sistema de PDV, integrando funcionalidades de vendas, estoque e adicionar produtos no carrinho. 
                    </p>
                    <a href=" https://github.com/isaactiago/projeto-pdv-symfony" target="_blank"> https://github.com/isaactiago/projeto-pdv-symfony</a>
                    </div>
                </div>

                <div class="cardItem">
                    <div class="card-body">
                    <h5 class="card-title text-center">Sistema de estoque</h5>
                    <p class="p">
                        Criei um sistema de gerenciamento de estoque onde cada produto tem sua categoria.
                    </p>
                    <a href=" https://github.com/isaactiago/symfony-projetoEstoque" target="_blank"> https://github.com/isaactiago/symfony-projetoEstoque</a>
                    </div>
                </div>
            </div>
        </>
    )
}